import { Component, OnInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { CompanyService } from 'src/services/company/company.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('0.6s ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.6s 0.3s ease-out', style({ opacity: 1 }))
      ])
    ]),
    trigger('slideInLeft', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(-20px)' }),
        animate('0.6s 0.4s ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ]),
    trigger('slideInRight', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(20px)' }),
        animate('0.6s 0.4s ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ])
    ])
  ]
})
export class HomeComponent implements OnInit {
  // Données pour les statistiques
  totalCompanies = 1245;
  totalContracts = 876;
  satisfactionRate = 98;

  // État pour les animations
  isVisible = false;

  constructor(public companyService: CompanyService) { }

  ngOnInit(): void {
    // Active les animations après un court délai
    setTimeout(() => {
      this.isVisible = true;
    }, 100);

    // Animation du compteur
    this.animateNumbers();
  }

  private animateNumbers(): void {
    // Implémentation de l'animation des nombres
    const animateValue = (id: string, start: number, end: number, duration: number) => {
      const obj = document.getElementById(id);
      if (!obj) return;
      
      let startTimestamp: number | null = null;
      const step = (timestamp: number) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const value = Math.floor(progress * (end - start) + start);
        obj.innerHTML = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    };

    // Démarrer les animations des compteurs
    setTimeout(() => {
      animateValue('totalCompanies', 0, this.totalCompanies, 2000);
      animateValue('totalContracts', 0, this.totalContracts, 2000);
      animateValue('satisfactionRate', 0, this.satisfactionRate, 2000);
    }, 1500);
  }
}